import { cn } from '@/lib/utils'

interface LoadingSpinnerProps {
	className?: string
	size?: 'sm' | 'md' | 'lg'
}

export function LoadingSpinner({ className, size = 'md' }: LoadingSpinnerProps) {
	const sizeClasses = {
		sm: 'size-4',
		md: 'size-8',
		lg: 'size-12',
	}

	return (
		<div
			className={cn(
				'relative',
				sizeClasses[size],
				className
			)}
			role="status"
			aria-label="Loading"
		>
			{/* Outer spinning ring */}
			<div className="absolute inset-0 animate-spin rounded-full border-2 border-transparent border-t-primary" />
			{/* Inner static ring for depth */}
			<div className="absolute inset-1 rounded-full border border-primary/20" />
		</div>
	)
}

export function FullPageLoader() {
	return (
		<div className="flex min-h-screen items-center justify-center bg-background">
			<div className="flex flex-col items-center gap-5">
				{/* Branded logo mark with pulse */}
				<div className="relative flex size-14 items-center justify-center">
					<div className="absolute inset-0 rounded-full bg-gradient-to-br from-primary/20 via-primary/5 to-transparent animate-pulse" />
					<div className="absolute inset-1.5 rounded-full bg-background" />
					<svg
						viewBox="0 0 24 24"
						className="relative z-10 size-6 fill-primary"
						aria-hidden="true"
					>
						<path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
					</svg>
					{/* Spinning ring around the logo */}
					<div className="absolute -inset-1 animate-spin rounded-full border border-transparent border-t-primary/40" style={{ animationDuration: '2s' }} />
				</div>
				<p className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground/40">
					Loading
				</p>
			</div>
		</div>
	)
}
